export const countryName = {
    '1' : '한국어',
    '2' : '일본어',
    '3' : '중국어',
    '30' : '영어',
    '81' : '스페인어',
}
